import { call, put, select } from 'redux-saga/effects';

import { getAggregates } from '@api/aggregates';
import { getCountrySpecificRules } from '@helpers/config';
import { intl } from '@helpers/intl';
import { aggregatesSummaryModel } from '@models/Filing/aggregatesSummary';
import {
  processingAggregatesStart,
  requestAggregatesFailure,
  requestAggregatesSuccess,
} from '@store/filing/aggregates/aggregates.reducer';
import { selectedFilingPeriodSelector } from '@store/selectors/savedFilingPeriod';

export const requestAggregatesSaga = function* ({ payload }) {
  try {
    const {
      countryIso,
      filingTypeNameShort,
      id: filingPeriodId,
    } = yield select(selectedFilingPeriodSelector);
    const disableOnlineTroubleshoot = getCountrySpecificRules(countryIso, 'filing')[
      filingTypeNameShort
    ]?.troubleshoot?.disableOnlineTroubleshoot;

    const response = yield call(getAggregates, payload.id);

    yield put(
      requestAggregatesSuccess(
        aggregatesSummaryModel(response, countryIso, filingPeriodId, disableOnlineTroubleshoot)
      )
    );
    if (payload.startPolling) yield put(processingAggregatesStart(payload.id));
  } catch (error) {
    const message =
      error.data?.nonFieldErrors ||
      intl.formatMessage({
        defaultMessage: 'An unexpected error occurred, please try again.',
        id: 'global.notification.api-error-default',
      });

    yield put(requestAggregatesFailure({ errorMessage: message }));
  }
};
